module.exports = __webpack_public_path__ + "static/media/Kit de Apoyo E2.92168ef3.zip";